import { MapDataItem, PolygonThemeSetting } from '@bpd-library/types';

import { clearHover, getHover, updateClick, updateHover } from '../../../store';
import { FeatureProperties, parseFeatureProperties } from '../parse-feature-properties';

type MapboxEvent = mapboxgl.MapMouseEvent & {
    features?: mapboxgl.MapboxGeoJSONFeature[] | undefined;
} & mapboxgl.EventData;

const getFeatureFromEvent = (e: MapboxEvent) => {
    const features = e.features;
    const feature = features ? features[0] : undefined;

    return feature || undefined;
};

const interaction = (map: mapboxgl.Map, setting: PolygonThemeSetting) => {
    map.on('mousemove', setting.variant + '-fill', (e) => {
        const hover = getHover();
        const feature = getFeatureFromEvent(e);

        if (!feature) return;

        if (hover.current?.id !== feature.id) {
            const item = parseFeatureProperties(
                feature.properties as FeatureProperties,
            ) as MapDataItem;

            updateHover(item);
        }
    });

    map.on('mouseleave', setting.variant + '-fill', () => {
        clearHover();
    });

    map.on('click', setting.variant + '-fill', (e) => {
        const feature = getFeatureFromEvent(e);

        if (feature) {
            const item = parseFeatureProperties(
                feature.properties as FeatureProperties,
            ) as MapDataItem;

            updateClick(item);
        }
    });
};

export default interaction;
